module.exports = __webpack_public_path__ + "static/img/circuit.1a84021.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/circuit.jpg
// module id = rgEB
// module chunks = 1